module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "content-class": "view-post-detail-modal",
      "max-width": "900px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('detailClosed')
      }
    },
    model: {
      value: (_vm.detailValue),
      callback: function($$v) {
        _vm.detailValue = $$v
      },
      expression: "detailValue"
    }
  }, [(_vm.postData !== null) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "text-no-wrap font-weight-bold"
        }, on), [_vm._v(_vm._s(_vm.campaignName) + " Campaign")])]
      }
    }], null, false, 1423457430)
  }, [_vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('span', [_vm._v("Submitted as "), _c('strong', [_vm._v(_vm._s(_vm.submittedCampaignName || _vm.campaignName + ' (Unverified)'))])]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeDetailModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-post-detail-modal__body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "md": "12",
      "xs": "12"
    }
  }, [_vm._l((_vm.postDetails), function(postData, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "md": "8",
        "xs": "12"
      }
    }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "12"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-history")]), _vm._v(" " + _vm._s(_vm.formatDate(postData.createdAt)) + "\n                        ")], 1)], 1), _vm._v(" "), (_vm.influencerData && !_vm.mappedInfluencerData) ? _c('div', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      attrs: {
        "xs": "6"
      }
    }, [(_vm.influencerData.platform === 'tiktok') ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "6"
      }
    }, [(postData.type) ? _c('v-chip', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(postData.type)) + "\n                            ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mappedInfluencerData && _vm.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      attrs: {
        "xs": "6"
      }
    }, [(_vm.mappedInfluencerData.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://tiktok.com/' + _vm.mappedInfluencerData.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.tiktokHandle))]) : (_vm.mappedInfluencerData.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.mappedInfluencerData.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.youtubeHandle))], 1) : (_vm.mappedInfluencerData.linkedinHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.mappedInfluencerData.linkedinHandle,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.linkedinHandle))], 1) : (postData.type === 'twitter' || _vm.mappedInfluencerData.twitterHandle) ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + (_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.mappedInfluencerData.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.instagramHandle))], 1)]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "6"
      }
    }, [(postData.type) ? _c('v-chip', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(postData.type)) + "\n                            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [(_vm.influencerData) ? _c('v-col', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v("\n                            Submitted By:\n                            "), _vm._v(" "), (_vm.influencerData.platform === 'tiktok') ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-sm": "",
        "container--fluid": ""
      }
    }, [_c('v-alert', {
      attrs: {
        "value": postData.images.length === 0,
        "color": "info",
        "icon": "info",
        "outlined": ""
      }
    }, [_vm._v("\n                          No Media found for this post.\n                        ")]), _vm._v(" "), (postData.images !== undefined) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": "",
        "justify-space-around": ""
      }
    }, _vm._l((postData.images), function(img) {
      return _c('v-flex', {
        key: img.url,
        attrs: {
          "md4": "",
          "xs12": ""
        }
      }, [(img.publicID && img.isvideo) ? _c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('custom-media-v2', {
        attrs: {
          "media": _vm.campaignHelper.customPostMediaConfig(img, {
            videoDownload: true
          })
        }
      })], 1) : _c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [(!img.isvideo) ? _c('v-hover', [(img.publicID) ? _c('div', {
        staticClass: "post-cld-img cursor-pointer",
        on: {
          "click": function($event) {
            return _vm.viewMedia(img)
          }
        }
      }, [_c('custom-media-v2', {
        attrs: {
          "media": _vm.campaignHelper.customPostMediaConfig(img, {
            trans: {
              width: 320,
              crop: 'scale'
            }
          })
        }
      })], 1) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.thumbnail || img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url, img.video)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('div', {
        staticClass: "elevation-8"
      }, [_c('video', {
        attrs: {
          "id": "previewVideo",
          "width": "100%",
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": img.url,
          "type": "video/mp4"
        }
      }), _vm._v("\n                                  Your browser does not support the video tag.\n                                ")])]) : _vm._e()], 1), _vm._v(" "), (img.type === 'video/quicktime') ? _c('btn-download', {
        attrs: {
          "url": img.url
        }
      }) : _vm._e()], 1)
    }), 1) : _vm._e()], 1), _vm._v(" "), (postData.captionText) ? _c('div', {
      staticClass: "body-1"
    }, [_c('v-textarea', {
      staticClass: "post-caption-textarea",
      attrs: {
        "readonly": "",
        "filled": "",
        "auto-grow": "",
        "rows": "4",
        "label": "Caption",
        "counter": ""
      },
      model: {
        value: (postData.captionText),
        callback: function($$v) {
          _vm.$set(postData, "captionText", $$v)
        },
        expression: "postData.captionText"
      }
    })], 1) : _vm._e(), _vm._v(" "), (postData.type === 'story' || postData.type === 'video' || postData.type === 'reel' || postData.type === 'tiktok' || postData.type === 'youtube' || postData.type === 'facebook') ? _c('div', [(postData.vdoLink) ? _c('div', {
      staticClass: "caption-label"
    }, [_vm._v(" \n                          Link\n                        ")]) : _vm._e(), _vm._v(" "), (postData.vdoLink) ? _c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                          " + _vm._s(postData.vdoLink) + "\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (postData.type === 'story' && _vm.currentUserRole !== 5) ? _c('div', {
      staticClass: "body-1"
    }, [_c('v-textarea', {
      attrs: {
        "readonly": "",
        "filled": "",
        "auto-grow": "",
        "rows": "4",
        "label": "Remark",
        "counter": ""
      },
      model: {
        value: (postData.remark),
        callback: function($$v) {
          _vm.$set(postData, "remark", $$v)
        },
        expression: "postData.remark"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": ""
      }
    }, [(postData.postDate) ? _c('div', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-chip', {
      staticClass: "subheading ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('span', [_vm._v("Scheduled: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(postData.postDate))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(postData.postDateEnd ? ("  to " + (postData.postDateEnd)) : ''))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-chip', {
      staticClass: "subheading ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('span', [_vm._v("Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loadPostStatusDisplay(postData)))])])], 1), _vm._v(" "), (postData.postURL) ? _c('div', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('v-chip', {
      staticClass: "subtitle-1 ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('strong', [_c('a', {
      attrs: {
        "href": postData.postURL,
        "target": "_blink"
      }
    }, [_vm._v("View Live Post")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.postReviewApproved) ? _c('v-flex', {
      attrs: {
        "centered": ""
      }
    }, [(postData.clientAcceptReview) ? _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-center",
      attrs: {
        "md6": "",
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "subtitle-1"
    }, [_vm._v("Rating on influencer's quality of work")]), _vm._v(" "), _c('v-rating', {
      staticClass: "ma-5",
      attrs: {
        "color": "secondary",
        "size": "30",
        "readonly": "",
        "dense": ""
      },
      model: {
        value: (postData.clientAcceptReview.rate),
        callback: function($$v) {
          _vm.$set(postData.clientAcceptReview, "rate", $$v)
        },
        expression: "postData.clientAcceptReview.rate"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(postData.clientAcceptReview.rate) + "/5 stars Rated")])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-center",
      attrs: {
        "md6": "",
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "max-width": "100"
      }
    }, [_c('p', [_vm._v("Comment for Influencer")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "text": "",
        "filled": "",
        "readonly": ""
      },
      model: {
        value: (postData.clientAcceptReview.comment),
        callback: function($$v) {
          _vm.$set(postData.clientAcceptReview, "comment", $$v)
        },
        expression: "postData.clientAcceptReview.comment"
      }
    })], 1)])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.postAbuseHistory && postData.clientReportAbuse.length > 0) ? _c('v-col', {
      attrs: {
        "md": "4",
        "xs": "12"
      }
    }, [_c('v-expansion-panels', {
      staticClass: "detail-report-abuse-section"
    }, _vm._l((postData.clientReportAbuse), function(item, i) {
      return _c('v-expansion-panel', {
        key: i
      }, [_c('v-expansion-panel-header', [_c('div', {
        staticClass: "subtitle-1",
        attrs: {
          "color": "red lighten-4"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "deep-orange"
        }
      }, [_vm._v("report_problem")]), _vm._v("\n                          Reported Abuse\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "report-abuse-expansion"
      }, [_c('v-card', [_c('v-card-text', {
        staticClass: "grey lighten-3 pl-1 pr-1"
      }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
        return _c('li', {
          key: r
        }, [_vm._v(_vm._s(r))])
      }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "max-height": "300px",
          "min-height": "200px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(item.comment))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "text-xs-right caption font-weight-italic"
      }, [_vm._v(_vm._s(_vm.formatDate(item.date)))]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
        return _c('li', {
          key: index
        }, [(f.url) ? _c('a', {
          attrs: {
            "href": f.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))]) : _vm._e()])
      }), 0)])]) : _vm._e()])], 1)], 1)], 1)
    }), 1)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('v-card', [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDetailModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('post-media-viewer-modal', {
    attrs: {
      "viewerValue": _vm.mediaViewerDialog,
      "media": _vm.mediaItem,
      "videoPlayer": _vm.videoPlayer
    },
    on: {
      "closed": _vm.closeMediaViewerModal
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7497676b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/ViewPostDetailModal.vue
// module id = 2200
// module chunks = 0